export default __webpack_public_path__ + "static/media/doglover.d08940fe.png";